import { Outlet, createFileRoute } from '@tanstack/react-router';

// const CustomerSettingsShell = React.lazy(
//   () =>
//     import(
//       '@/modules/backoffice/customers/components/layout/CustomerSettingsShell'
//     ),
// );

export const Route = createFileRoute(
  '/_authenticated/backoffice/customers/$customerId',
)({
  component: function Component() {
    // const { customerId } = Route.useParams();

    return (
      // <CustomerSettingsShell customerId={customerId}>
      <Outlet />
      // </CustomerSettingsShell>
    );
  },
});
